/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_CashInputs */

const vi_payment_method_cash = /** @type {(inputs: Payment_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt`)
};

/**

* @param {Payment_Method_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_cash = /** @type {((inputs?: Payment_Method_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_cash(inputs)
});